import { required, SelectInput } from "react-admin";

export const tbfCodeList = [
  { id: "TERM-1", name: "School Term 1" },
  { id: "TERM-2", name: "School Term 2" },
  { id: "TERM-3", name: "School Term 3" },
  { id: "TERM-4", name: "School Term 4" },
  { id: "TERM-5", name: "School Term 5" },
  { id: "TERM-6", name: "School Term 6" },
  { id: "TERM-7", name: "School Term 7" },
  { id: "TERM-8", name: "School Term 8" },
  { id: "TERM-9", name: "School Term 9" },
  { id: "TERM-10", name: "School Term 10" },
  { id: "TERM-11", name: "School Term 11" },
  { id: "TERM-12", name: "School Term 12" },
];

const TbfCodeInput = () => {
  return (
    <SelectInput source="tbfCode" choices={tbfCodeList} validate={required()} />
  );
};

export default TbfCodeInput;
